import { FocusEventHandler, forwardRef } from 'react';

interface MenuItemProps {
  text: string;
  value: number;
  minusButtonDisabled?: boolean;
  plusButtonDisabled?: boolean;
  onMinusClick: () => void;
  onPlusClick: () => void;
  onBlur?: FocusEventHandler<HTMLButtonElement>;
  buttonName?: string;
}

const MenuItem = forwardRef<HTMLButtonElement, MenuItemProps>(function InnerMenuItem(
  {
    text,
    value,
    minusButtonDisabled,
    plusButtonDisabled,
    onMinusClick,
    onPlusClick,
    onBlur,
    buttonName,
  },
  ref,
) {
  return (
    <div className="flex justify-between p-4 items-center border-b">
      <span className="capitalize">{text}</span>
      <div className="flex items-center gap-x-2">
        <button
          type="button"
          disabled={minusButtonDisabled}
          onBlur={onBlur}
          ref={ref}
          name={buttonName}
          onClick={() => onMinusClick()}
          className="disabled:text-gray-300"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="currentColor"
            viewBox="0 0 256 256"
          >
            <path d="M180,128a12,12,0,0,1-12,12H88a12,12,0,0,1,0-24h80A12,12,0,0,1,180,128Zm56,0A108,108,0,1,1,128,20,108.12,108.12,0,0,1,236,128Zm-24,0a84,84,0,1,0-84,84A84.09,84.09,0,0,0,212,128Z"></path>
          </svg>
        </button>
        <span className="w-4 text-center">{value}</span>
        <button
          type="button"
          disabled={plusButtonDisabled}
          onBlur={onBlur}
          ref={ref}
          name={buttonName}
          onClick={() => onPlusClick()}
          className="disabled:text-gray-300"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="currentColor"
            viewBox="0 0 256 256"
          >
            <path d="M128,20A108,108,0,1,0,236,128,108.12,108.12,0,0,0,128,20Zm0,192a84,84,0,1,1,84-84A84.09,84.09,0,0,1,128,212Zm52-84a12,12,0,0,1-12,12H140v28a12,12,0,0,1-24,0V140H88a12,12,0,0,1,0-24h28V88a12,12,0,0,1,24,0v28h28A12,12,0,0,1,180,128Z"></path>
          </svg>
        </button>
      </div>
    </div>
  );
});

export default MenuItem;
